"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _api = require("@react-google-maps/api");

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  googlemap: {
    backgroundColor: "#e5e3df",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%"
  }
}));

const GeopointMap = ({
  className,
  center,
  zoom,
  onChange,
  options,
  children
}) => {
  const _useState = (0, _react.useState)(null),
        map = _useState[0],
        setMap = _useState[1];

  const handleChange = () => {
    map && onChange && onChange(map);
  };

  const classes = useStyles();
  return _react.default.createElement(_api.GoogleMap, {
    id: "mymap",
    options: options,
    clickableIcons: false,
    mapContainerClassName: className || classes.googlemap,
    center: center,
    zoom: zoom,
    onLoad: map => setMap(map),
    onZoomChanged: handleChange,
    onDragEnd: handleChange
  }, children);
};

GeopointMap.defaultProps = {
  options: {
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false
  },
  center: {
    lat: undefined,
    lng: undefined
  },
  zoom: 12
};
var _default = GeopointMap;
exports.default = _default;
module.exports = exports.default;